/**
 * Scrolls the page so `target` sits partway down the viewport.
 * Starts at full speed and decelerates smoothly into the destination.
 *
 * @param {Element} trigger - The element that was clicked.
 * @param {Element|string} target - The element (or selector) to scroll to.
 * @param {Object} [options]
 * @param {number} [options.duration=320] - Scroll duration in ms.
 * @param {number} [options.offsetRatio=0.2] - Where the target lands vertically
 *   (0.2 = 20% down from the top of the screen).
 */


function smoothScrollTo(trigger, target, options = {}) {
  const { duration = 700, offsetRatio = 0.2 } = options;

  const targetEl =
    typeof target === 'string' ? document.querySelector(target) : target;
  if (!targetEl) return;

  const startY = window.scrollY;
  const offset = window.innerHeight * offsetRatio;

  // Clamp so we never try to scroll past the bottom of the page
  const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
  const endY = Math.min(
    Math.max(targetEl.getBoundingClientRect().top + startY - offset, 0),
    maxScroll
  );

  const distance = endY - startY;
  if (distance === 0) return;

  // Temporarily neutralize CSS `scroll-behavior: smooth` (even !important)
  // so it can't hijack our per-frame scrollTo calls. Restored when done.
  const root = document.documentElement;
  const prevBehavior = root.style.getPropertyValue('scroll-behavior');
  const prevPriority = root.style.getPropertyPriority('scroll-behavior');
  root.style.setProperty('scroll-behavior', 'auto', 'important');

  function restoreScrollBehavior() {
    if (prevBehavior) {
      root.style.setProperty('scroll-behavior', prevBehavior, prevPriority);
    } else {
      root.style.removeProperty('scroll-behavior');
    }
  }

  let startTime = null;

  // Full speed at the start, decelerating smoothly into the destination.
  const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);

  function step(timestamp) {
    if (startTime === null) startTime = timestamp;
    const progress = Math.min((timestamp - startTime) / duration, 1);
    // 'instant' is critical: if your CSS has `scroll-behavior: smooth`,
    // plain scrollTo(x, y) triggers a *native* animated scroll on every
    // frame, which lags behind and then snaps at the end.
    window.scrollTo({
      top: startY + distance * easeOutCubic(progress),
      behavior: 'instant',
    });
    if (progress < 1) {
      requestAnimationFrame(step);
    } else {
      restoreScrollBehavior();
    }
  }

  requestAnimationFrame(step);
}
/* ---------- Usage example ---------- */


window.smoothScrollTo = smoothScrollTo;

let errorSection = document.querySelectorAll('.whole-section-hider');

errorSection.forEach((section) => {
  section.addEventListener('click', (event) => {
    event.preventDefault();
    smoothScrollTo(section, '#please_upload_text');
  });
});
